/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import { Col, Row } from 'antd';

import { TextField, CheckboxField, CampaignField, SelectField } from '@molecules';
import MediaField from '@organisms/MediaField';
import { Block, ErrorMessage, Typography } from '@atoms';

import RelatedContentField from '../RelatedContentField';
import Form from '../Form';

import { FORM_FIELD, FORM_FIELDS, DEFAULT_VALUES } from './constants';

const VideoForm = ({ initialValues = {}, error, form }) => {
  const [isGated, setIsGated] = useState(initialValues.isGatedContent || false);

  const handleValuesChange = React.useCallback((change) => {
    if (FORM_FIELD.GATED_CONTENT.name in change) {
      setIsGated(change[FORM_FIELD.GATED_CONTENT.name]);
    }
  }, []);

  const changeTitle = React.useCallback(
    (title) => {
      // for videos without title
      const thumbnailImage = form.getFieldValue(FORM_FIELD.THUMBNAIL_FEATURE_IMAGE.name) || {};
      form.setFieldsValue({
        [FORM_FIELD.THUMBNAIL_FEATURE_IMAGE.name]: { ...thumbnailImage, title },
      });
    },
    [form],
  );

  return (
    <Form form={form} layout="vertical" initialValues={initialValues} onValuesChange={handleValuesChange}>
      <ErrorMessage error={error} variant="block" spaced />

      <Block>
        <TextField {...FORM_FIELD.TITLE} extra={null} wrapperCol={{ span: 24 }} />
        <MediaField {...FORM_FIELD.THUMBNAIL_FEATURE_IMAGE} handlerTitle={changeTitle} />
        <TextField {...FORM_FIELD.VIDEO_ID} wrapperCol={{ span: 24 }} />
        <TextField {...FORM_FIELD.PLAYER_ID} wrapperCol={{ span: 24 }} />
        <TextField {...FORM_FIELD.STANDFIRST} extra={null} wrapperCol={{ span: 24 }} />
        <TextField {...FORM_FIELD.LANGUAGE} style={{ display: 'none' }} />
        <TextField {...FORM_FIELD.METATAGS} />

        <CheckboxField {...FORM_FIELD.GATED_CONTENT} />
        {isGated && <CampaignField {...FORM_FIELD.CAMPAIGN} />}
        <Typography.Paragraph>CTA</Typography.Paragraph>
        <Row gutter={16}>
          <Col span={8}>
            <SelectField {...FORM_FIELD.SIGNED_IN_CTA} />
          </Col>
          <Col span={8}>
            <SelectField {...FORM_FIELD.SIGNED_OUT_CTA} />
          </Col>
        </Row>
      </Block>
      <Block spaced>
        <RelatedContentField form={form} fields={FORM_FIELDS} />
      </Block>
    </Form>
  );
};

VideoForm.useForm = () => Form.useForm(FORM_FIELDS, DEFAULT_VALUES);
VideoForm.FORM_FIELD = FORM_FIELD;

export default VideoForm;
